import { Toolbar } from "../../../../../_metronic/layout/components/header/Toolbar";

const StatoPresseToolbar = () => {
  return <Toolbar></Toolbar>;
};

export default StatoPresseToolbar;
